export default function CustomCard(props: any) {
  return (
    <div className='card p-0'>
      <div className='card-body px-4' style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 300px)' }}>
        {props.children}
      </div>
    </div>
  )
}
